import { render, staticRenderFns } from "./DeleteEntityDialog.vue?vue&type=template&id=2b943660&"
import script from "./DeleteEntityDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteEntityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DeleteEntityDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports